import React, {useCallback} from 'react';
import useChampionFunc from "./useChampionFunc";

const UseBuildSkillSq = ({skillList,champion_id,list}) => {
    const {getChampion} = useChampionFunc()
    const champion = getChampion(champion_id);
    const getLastSkills = useCallback((array) => {
        try {
            if (Array.isArray(array)) {
                const sliceArray = array.slice(0, 14);
                const qIndex = sliceArray.lastIndexOf(1);
                const qCount = sliceArray.filter((data) => data === 1).length;
                const qMastered = qCount >= skillList?.spells[0].cost.length ? 1 : 0;
                const wIndex = sliceArray.lastIndexOf(2);
                const wCount = sliceArray.filter((data) => data === 2).length
                const wMastered = wCount >= skillList?.spells[1].cost.length ? 1 : 0;
                const eIndex = sliceArray.lastIndexOf(3);
                const eCount = sliceArray.filter((data) => data === 3).length
                const eMastered = eCount >= skillList?.spells[2].cost.length ? 1 : 0;
                const rIndex = sliceArray.lastIndexOf(4);
                const rCount = sliceArray.filter((data) => data === 4).length
                const rMastered = rCount >= skillList?.spells[3]?.cost.length ? 1 : 0;
                let indexArray = [{
                    index: qIndex,
                    count: qCount,
                    mastered: qMastered,
                    value: 1,
                    text: 'Q'
                }, {
                    index: wIndex,
                    count: wCount,
                    mastered: wMastered,
                    value: 2,
                    text: 'W'
                }, {
                    index: eIndex,
                    count: eCount,
                    mastered: eMastered,
                    value: 3,
                    text: 'E'
                }];

                //77 == 우디르
                if (Number(champion?.champion_id) === 77) {
                    indexArray = [
                        ...indexArray,
                        {
                            index: rIndex,
                            count: rCount,
                            mastered: rMastered,
                            value: 4,
                            text: 'R'
                        }];
                }


                indexArray.sort((a, b) => {
                    if (a.mastered < b.mastered) {
                        return 1;
                    } else if (a.mastered > b.mastered) {
                        return -1;
                    } else if (a.count < b.count) {
                        return 1;
                    } else if (a.count > b.count) {
                        return -1;
                    } else if (a.index > b.index) {
                        return 1;
                    } else if (a.index < b.index) {
                        return -1;
                    }
                    return 0;
                });
                return indexArray || [];
            }
            return [];
        } catch (e) {
            console.log(e);
            return [];
        }

    }, [skillList])
    const skillValue = getLastSkills(list)
    return {
        skillValue
    }
};

export default UseBuildSkillSq;